<template>
  <div class="site-mobile-menu">

    <Transition name="fade">
      <SiteMenu
        v-if="props.open"
        @go-to="goButWait"
        class="site-mobile-menu__menu"
      >
        <SiteMenuButton
          class="site-menu-button"
          :label="siteIdentity.authentity.value ? 'Aller sur l\'app' : 'Connexion'"
          :href="href"
          @click.prevent="loginOrGo"
        />
      </SiteMenu>
    </Transition>

    <Transition name="move">
      <div
        v-if="props.open"
        class="site-mobile-menu__background"
      />
    </Transition>
  </div>
  
</template>


<script setup>
  import SiteMenu from '@/sections/SiteHeader/SiteMenu'
  import SiteMenuButton from '@/sections/SiteHeader/SiteMenuButton'
  import useSiteIdentity from '@/components/SiteIdentity'

  const siteIdentity = useSiteIdentity()

  const router = await useRouter()

  const props = defineProps({
    open: Boolean
  })

  const emit = defineEmits(['open', 'login'])

  const goButWait = (target) => {
    emit('open', false)
    if (target) {
      setTimeout(() => {
        router.push(target)
      }, 630)
    }
  }

  const href = computed(() => {
    if (siteIdentity.authentity.value) {
      return '/app'
    } else {
      return undefined
    }
  })

  const loginOrGo = () => {
    if (siteIdentity.authentity.value) {
      emit('open', false)
      setTimeout(() => {
        router.push({ name: 'app' })
      }, 630)
    } else {
      emit('open', false)
      setTimeout(() => {
        router.push({ name: 'app' })
      }, 630)
    }
  }
</script>
<style lang="scss" scoped>
  @use './index.scss';
</style>